// TODO: add to theme
export const LEFT_SIDE_MENU_WIDTH = '64px';
export const LEFT_SIDE_SPACING_BOTTOM_PANEL = 245;
